import * as React from "react";
import {
  Button,
  Card,
  Chip,
  Box,
  Container,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Select,
  MenuItem,
  Stack,
  FormLabel,
  CircularProgress,
  NativeSelect,
  FormControl,
  InputLabel,
  Tab,
  Menu,
  FormControlLabel,
  Tooltip,
  TableCell,
  IconButton,
  Table,
  TableBody,
  TableRow,
  styled,
  tableCellClasses,
  Link,
  Radio,
  RadioGroup,
  Alert,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  GridColDef,
  GridFilterInputValueProps,
  GridFilterItem,
  GridFilterOperator,
  GridRenderCellParams,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import Grid from "@mui/material/Grid";
import {
  useAddPriceRuleMutation,
  useSetShowHideMutation,
  useSetEnableDisableMutation,
  useDeleteProductsMutation,
  useSetEnableDisableByItemMutation,
  useGetSyncedProductsMutation,
  useGetDealerManufacturersQuery,
  addDealerManufacturers,
  useSetDmsSyncStatusMutation,
  useGetWGSerialNumbersMutation,
  useUpdateAggregatePriceMutation,
  useHidePricesInBulkMutation,
} from "../../../redux/reducer/features/Integration/DmsSetupSlice";
import { useRevertShopifyCustomDetailsMutation } from "../../../redux/reducer/features/Product/productSlice";
import { AppState } from "../../../redux/reducer/rootReducer";
import Switch from "@mui/material/Switch";
import ServerAppGrid from "../../app/ServerAppGrid";
import { AppFilter } from "../../../models/app/AppModels";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import CardContent from "@mui/material/CardContent";
import {
  DisableOption,
  EntityType,
  PricingType,
  UnitPriceType,
} from "../../../models/features/Integration/DmsSetup";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  setDisablePriceSync,
  setDisableStockSync,
  setEnableCatalogSync,
} from "../../../redux/reducer/features/Auth/authSlice";
import { useGetDmsManufacturersQuery } from "../../../redux/reducer/features/ShoppingPortal/ShoppingPortalSlice";
import { DmsManufacturer } from "../../../models/features/ShoppingPortal/DmsManufacturer";
import CloseIcon from "@mui/icons-material/Close";
import GridWithNewPrices from "./Grids/GridWithNewPrices";
import GetPriceNames from "./GetPriceNames";
import { AppGridId } from "../../../models/app/AppGridModels";
import { GetAppGridColumns } from "../../../services/utilities/utility";
import WarningIcon from "@mui/icons-material/Warning";
import { customPriceFilterOperators } from "../../app/CustomGridFilterOpereators";
import ShopifyProductDetails from "../../Used Products/ShopifyProductDetails";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ManageHistoryIcon from "@mui/icons-material/ManageHistory";
const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: "2px",
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));
interface ProductManageProps {}

const ProductManagement: React.FunctionComponent<ProductManageProps> = () => {
  const WGgridSetting = useSelector((state: AppState) =>
    state?.AppGridReducer?.setting.find(
      (x) => x.gridId === AppGridId.Product_Manager_Wholegoods
    )
  );
  const PartgridSetting = useSelector((state: AppState) =>
    state?.AppGridReducer?.setting.find(
      (x) => x.gridId === AppGridId.Product_Manager_Parts
    )
  );
  const [paging, setPaging] = React.useState<AppFilter>({
    pageIndex: 0,
    pageSize: 10,
    totalRecords: 0,
    items: [],
    quickFilterValues: [],
  });
  const productTypes = useSelector(
    (state: AppState) => state.authReducer.dmsSetup?.productTypes
  );
  const locations = useSelector(
    (state: AppState) => state.authReducer.dmsSetup?.dmsLocations
  );
  const [filteredManufacturers, setFilteredManufacturers] = React.useState<
    DmsManufacturer[]
  >([]);
  const [value, setValue] = React.useState("Wholegoods");
  const dispatch = useDispatch();
  const [showErrorMessage, setShowErrorMessage] = React.useState("");
  const [products, setProducts] = React.useState<any[]>([]);
  const [productsCount, setProductsCount] = React.useState<number>(0);
  const [selectedRows, setSelectedRows] = React.useState<any>([]);
  const [selectedRowData, setSelectedRowData] = React.useState<any>();
  const [open, setOpen] = React.useState(false);
  const [isResetRequest, setIsResetRequest] = React.useState(false);
  const [openPrices, setOpenPrices] = React.useState(false);
  const [WGSerials, setWGSerials] = React.useState<any[]>([]);
  const [priceTabsvalue, setPriceTabsValue] = React.useState("Prices");
  const [openPriceRule, setOpenPriceRule] = React.useState(false);
  const [openHidePrice, setOpenHidePrice] = React.useState(false);
  const [isOperationRunning, setIsOperationRunning] = React.useState(false);
  const [hideValue, setHideValue] = React.useState(false);
  const [openPriceType, setOpenPriceType] = React.useState(false);
  const [priceType, setPriceType] = React.useState<PricingType>();
  const [serialNumber, setSerialNumber] = React.useState<string | null>(null);
  const [productType, setProductType] = React.useState(0);
  const [openStockForm, setOpenStockForm] = React.useState(false);
  const [checked, setChecked] = React.useState(true);
  const [openShopifyDetails, setOpenShopifyDetails] = React.useState(false);
  const [openRevertCustom, setOpenRevertCustom] = React.useState(false);
  const [formData, setFormData] = React.useState({
    method: "+",
    amount: 0,
    applyOn: "$",
  });
  const setupId = useSelector((state: AppState) => state.authReducer.setupId);
  const { everestDmsDealerId } = useSelector(
    (state: AppState) => state.authReducer
  );

  const { dmsSetup } = useSelector((state: AppState) => state.authReducer);
  const { data: dmsManufacturersList } = useGetDmsManufacturersQuery({
    dealerId: locations ? locations[0].dealerId.toString() ?? "" : "",
  });

  const { dealerManufacturers } = useSelector(
    (state: AppState) => state.dmsReducer
  );

  const manufacturersQuery = useGetDealerManufacturersQuery(
    {},
    { skip: !(dealerManufacturers.length === 0) }
  );

  const [syncProduct, syncProductResult] = useGetSyncedProductsMutation();
  const [addPriceRule, addPriceRuleMutationResult] = useAddPriceRuleMutation();
  const [setSyncStatusMutation, setSyncStatusMutationResult] =
    useSetDmsSyncStatusMutation();
  const [setVisibility, setVisibilityMutationResult] = useSetShowHideMutation();
  const [setStockDecision, setStockDecisionMutationResult] =
    useSetEnableDisableMutation();
  const [setStockDecisionByItem, setStockDecisionByItemMutationResult] =
    useSetEnableDisableByItemMutation();
  const [setDeleteProducts, setDeleteProductsMutationResult] =
    useDeleteProductsMutation();
  const [getWGSerialsMutation, getWGSerialsMutationResult] =
    useGetWGSerialNumbersMutation();
  const [updatePriceMutation, updatePriceMutationResult] =
    useUpdateAggregatePriceMutation();
  const [hidePriceMutation, hidePriceMutationMutationResult] =
    useHidePricesInBulkMutation();
  const [revertCustomDetailsMutation, revertCustomDetailsMutationResult] =
    useRevertShopifyCustomDetailsMutation();
  const [deleteConfirm, setDeleteConfirm] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [anchorAction, setAnchorAction] = React.useState<null | HTMLElement>(
    null
  );
  const [anchorUnitPrice, setAnchorUnitPrice] =
    React.useState<null | HTMLElement>(null);

  const openPriceMenu = Boolean(anchorEl);
  const openUnitPriceMenu = Boolean(anchorUnitPrice);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClickUnitPrice = (
    event: React.MouseEvent<HTMLButtonElement>,
    serialNumber: string
  ) => {
    setSerialNumber(serialNumber);
    setAnchorUnitPrice(event.currentTarget);
  };

  const handleGetWGSerials = (model: string, mfrCode?: string) => {
    setPriceTabsValue("Prices");
    setOpenPrices(true);
    getWGSerialsMutation({
      request: {
        dealerIds: locations?.map((loc) => loc.dealerId.toString()) ?? [],
        everestDmsDealerId: everestDmsDealerId?.toString() ?? "",
        model: model,
        mfrCode: mfrCode ?? "",
      },
    }).then((res: any) => {
      if (res.data && res.data.status === 200) {
        setWGSerials(res.data.entityList);
      }
    });
  };

  const handleUpdatePrice = (
    priceType: PricingType,
    unitPriceType: UnitPriceType | null,
    isResetRequest: boolean
  ) => {
    setPriceType(priceType);
    setIsResetRequest(isResetRequest);
    let prices = selectedRowData.aggregatePrices;
    var selectedPrice = 0;

    switch (priceType) {
      case PricingType.Price:
        selectedPrice = prices.price;
        break;
      case PricingType.RetailPrice:
        selectedPrice = prices?.aggregatePrices?.msrpListPriceLatestStock;
        break;
      case PricingType.UnitPrice:
        if (unitPriceType === UnitPriceType.UnitList) {
          selectedPrice = WGSerials.find(
            (wg: any) => wg?.serialNumber === serialNumber
          ).price;
        } else if (unitPriceType === UnitPriceType.MSRPList) {
          selectedPrice = WGSerials.find(
            (wg: any) => wg?.serialNumber === serialNumber
          ).suggestedRetailPrice;
        }
        break;
      case PricingType.UnitListPriceLargest:
        selectedPrice = prices?.unitListPriceLargest;
        break;
      case PricingType.UnitListPriceSmallest:
        selectedPrice = prices?.unitListPriceSmallest;
        break;
      case PricingType.UnitListPriceLatest:
        selectedPrice = prices?.unitListPriceLatest;
        break;
      case PricingType.UnitListPriceLargestStock:
        selectedPrice = prices?.unitListPriceLargestStock;
        break;
      case PricingType.UnitListPriceSmallestStock:
        selectedPrice = prices?.unitListPriceSmallestStock;
        break;
      case PricingType.UnitListPriceLatestStock:
        selectedPrice = prices?.unitListPriceLatestStock;
        break;
      case PricingType.MSRPListPriceLargest:
        selectedPrice = prices?.msrpListPriceLargest;
        break;
      case PricingType.MSRPListPriceSmallest:
        selectedPrice = prices?.msrpListPriceSmallest;
        break;
      case PricingType.MSRPListPriceLatest:
        selectedPrice = prices?.msrpListPriceLatest;
        break;
      case PricingType.MSRPListPriceLargestStock:
        selectedPrice = prices?.msrpListPriceLargestStock;
        break;
      case PricingType.MSRPListPriceSmallestStock:
        selectedPrice = prices?.msrpListPriceSmallestStock;
        break;
      case PricingType.MSRPListPriceLatestStock:
        selectedPrice = prices?.msrpListPriceLatestStock;
        break;
      default:
        console.log("Invalid price type");
    }

    updatePriceMutation({
      isResetPrice: isResetRequest,
      aggregateId: selectedRowData?.id ?? "",
      shopifyProductId: selectedRowData?.shopifyProductId ?? 0,
      price: selectedPrice,
      aggregatePriceType: priceType,
      serialNumber: serialNumber,
      unitPriceType: priceType === PricingType.UnitPrice ? unitPriceType : null,
    }).then((res: any) => {
      if (res.data && res.data.status === 200) {
        fetchData();
        setOpenPrices(false);
        setIsResetRequest(false);
      }
    });
  };

  React.useEffect(() => {
    if (
      dmsManufacturersList?.entityList &&
      dmsManufacturersList.entityList?.length > 0
    ) {
      setFilteredManufacturers(dmsManufacturersList.entityList);
    }
  }, [dmsManufacturersList]);

  const handleTabChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
    if (newValue === "Wholegoods") {
      setProductType(0);
    } else {
      setProductType(1);
    }
    setPaging({ ...paging, quickFilterValues: [], items: [] });
  };
  const handlePriceChartTabChange = (
    event: React.SyntheticEvent,
    newValue: string
  ) => {
    setPriceTabsValue(newValue);
  };
  const handleChange = (event: any) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };
  const handleDecisionChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setChecked(event.target.checked);
  };

  const handleDecisionChangeSingleItem = (product: any, checked: boolean) => {
    setProducts(
      products.map((item) =>
        item.id === product.productAggId
          ? {
              ...item,
              shopifyProduct: {
                ...item.shopifyProduct,
                variants: [
                  {
                    ...item.shopifyProduct.variants[0],
                    inventoryPolicy: checked ? "continue" : "deny",
                  },
                ],
              },
            }
          : item
      )
    );

    handleStockDecisionSubmitByItem(product, checked ? "yes" : "no");
  };
  const handleClose = () => {
    setAnchorAction(null);
    setOpenShopifyDetails(false);
    setOpen(false);
    setOpenPrices(false);
    setOpenPriceType(false);
    setOpenPriceRule(false);
    setAnchorEl(null);
    setOpenStockForm(false);
    setDeleteConfirm(false);
    setOpenHidePrice(false);
    setOpenRevertCustom(false);
    setShowErrorMessage("");
  };
  const handleUnitPriceClose = () => {
    setAnchorUnitPrice(null);
  };
  const handleGetRowColor = (price: PricingType) => {
    let color = "";
    if (selectedRowData?.pricing === PricingType[price]) {
      color = "rgb(237, 247, 237)";
    }
    return color;
  };
  const handleGetModelPrice = (product: any) => {
    var selectedPrice = 0;
    if (product?.aggregatePrices !== null) {
      switch (PricingType[product.pricing as keyof typeof PricingType]) {
        case PricingType.Price:
          selectedPrice =
            product?.aggregatePrices?.price !== null
              ? product?.aggregatePrices?.price
              : product?.price;
          break;
        case PricingType.RetailPrice:
          selectedPrice = product?.aggregatePrices?.msrpListPriceLatestStock;
          break;
        case PricingType.UnitListPriceLargest:
          selectedPrice = product.aggregatePrices.unitListPriceLargest;
          break;
        case PricingType.UnitListPriceSmallest:
          selectedPrice = product.aggregatePrices.unitListPriceSmallest;
          break;
        case PricingType.UnitListPriceLatest:
          selectedPrice = product.aggregatePrices.unitListPriceLatest;
          break;
        case PricingType.MSRPListPriceLargest:
          selectedPrice = product.aggregatePrices.msrpListPriceLargest;
          break;
        case PricingType.MSRPListPriceSmallest:
          selectedPrice = product.aggregatePrices.msrpListPriceSmallest;
          break;
        case PricingType.MSRPListPriceLatest:
          selectedPrice = product.aggregatePrices.msrpListPriceLatest;
          break;
        case PricingType.UnitListPriceLargestStock:
          selectedPrice = product?.aggregatePrices?.unitListPriceLargestStock;
          break;
        case PricingType.UnitListPriceSmallestStock:
          selectedPrice = product?.aggregatePrices?.unitListPriceSmallestStock;
          break;
        case PricingType.UnitListPriceLatestStock:
          selectedPrice = product?.aggregatePrices?.unitListPriceLatestStock;
          break;
        case PricingType.MSRPListPriceLargestStock:
          selectedPrice = product?.aggregatePrices?.msrpListPriceLargestStock;
          break;
        case PricingType.MSRPListPriceSmallestStock:
          selectedPrice = product?.aggregatePrices?.msrpListPriceSmallestStock;
          break;
        case PricingType.MSRPListPriceLatestStock:
          selectedPrice = product?.aggregatePrices?.msrpListPriceLatestStock;
          break;
        default:
          console.log("Invalid price type");
      }
    }
    if (
      selectedPrice === 0 ||
      selectedPrice === null ||
      selectedPrice === undefined
    ) {
      selectedPrice = product?.price ?? 0;
      if (selectedPrice === null || selectedPrice === undefined) {
        selectedPrice = 0;
      }
    }
    return selectedPrice.toFixed(2);
  };

  const handleGetGeneralPrice = (product: any) => {
    var selectedPrice = 0;
    if (product?.aggregatePrices !== null) {
      switch (
        PricingType[dmsSetup?.pricing ?? ("Price" as keyof typeof PricingType)]
      ) {
        case PricingType.Price:
          selectedPrice =
            product?.aggregatePrices?.price !== null
              ? product?.aggregatePrices?.price
              : product?.price;
          break;
        case PricingType.RetailPrice:
          selectedPrice = product?.aggregatePrices?.msrpListPriceLatestStock;
          break;
        case PricingType.UnitListPriceLargestStock:
          selectedPrice = product?.aggregatePrices?.unitListPriceLargestStock;
          break;
        case PricingType.UnitListPriceSmallestStock:
          selectedPrice = product?.aggregatePrices?.unitListPriceSmallestStock;
          break;
        case PricingType.UnitListPriceLatestStock:
          selectedPrice = product?.aggregatePrices?.unitListPriceLatestStock;
          break;
        case PricingType.MSRPListPriceLargestStock:
          selectedPrice = product?.aggregatePrices?.msrpListPriceLargestStock;
          break;
        case PricingType.MSRPListPriceSmallestStock:
          selectedPrice = product?.aggregatePrices?.msrpListPriceSmallestStock;
          break;
        case PricingType.MSRPListPriceLatestStock:
          selectedPrice = product?.aggregatePrices?.msrpListPriceLatestStock;
          break;
        default:
          console.log("Invalid price type");
      }
    }
    if (
      selectedPrice === 0 ||
      selectedPrice === null ||
      selectedPrice === undefined
    ) {
      selectedPrice = product?.price ?? 0;
      if (selectedPrice === null || selectedPrice === undefined) {
        selectedPrice = 0;
      }
    }

    return selectedPrice.toFixed(2);
  };
  const handleRevertCustomDetails = () => {
    revertCustomDetailsMutation({ aggregateId: selectedRowData?.id }).then(
      (res: any) => {
        if (res.data && res.data.status === 200) {
          fetchData();
          setOpenRevertCustom(false);
        }
      }
    );
  };
  function RatingInputValue(props: GridFilterInputValueProps) {
    const { item, applyValue, focusElementRef } = props;

    const ratingRef: React.Ref<any> = React.useRef(null);

    const handleDropdownFilterChange = (event: any) => {
      applyValue({
        ...item,
        value: event.target.value !== "all" ? event.target.value : undefined,
      });
    };
    return (
      <FormControl fullWidth>
        <InputLabel variant="standard" htmlFor="uncontrolled-native">
          Manufacturer
        </InputLabel>
        <NativeSelect
          ref={ratingRef}
          value={item.value ? item.value : "all"}
          defaultValue="all"
          inputProps={{
            name: "age",
            id: "uncontrolled-native",
          }}
          onChange={handleDropdownFilterChange}
        >
          <option value={"all"}>All</option>
          {filteredManufacturers.map((n) => (
            <option value={n.code}>{n.code}</option>
          ))}
          {dealerManufacturers.map((n) => (
            <option value={n.title}>{n.title}</option>
          ))}
        </NativeSelect>
      </FormControl>
    );
  }
  const handleUpdateProductMatchingType = (productId: string, type: string) => {
    setProducts(
      products.map((item) =>
        item.id === productId
          ? {
              ...item,
              matchingType: type,
            }
          : item
      )
    );
  };
  const ratingOnlyOperators: GridFilterOperator[] = [
    {
      label: "Equals",
      value: "equals",
      getApplyFilterFn: (filterItem: GridFilterItem) => {
        if (
          !filterItem.columnField ||
          !filterItem.value ||
          !filterItem.operatorValue
        ) {
          return null;
        }

        return (params): boolean => {
          return params.value == filterItem.value;
        };
      },
      InputComponent: RatingInputValue,
      InputComponentProps: { type: "number" },
    },
  ];

  const columns: GridColDef[] = [
    {
      field: "manufacturer",
      headerName: "Manufacturer",
      width: 110,
      filterOperators: ratingOnlyOperators,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Tooltip title={params.row.manufacturer}>
            <Typography sx={{ fontSize: "0.875rem" }}>
              {params.row.manufacturer}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "modelName",
      headerName: "Model Name",
      width: 210,
      renderCell: (params: GridRenderCellParams) => {
        return params.row.productId ? (
          <>
            <Box
              style={{
                width: "50px",
                height: "50px",
                backgroundColor: "white",
              }}
            >
              <img
                style={{ maxWidth: "100%", maxHeight: "100%" }}
                alt=""
                src={getIconImageUrl(
                  params.row.shopifyProduct &&
                    params.row.shopifyProduct.images.length !== 0
                    ? params.row.shopifyProduct.images[0].src
                    : ""
                )}
              ></img>{" "}
            </Box>
            <Tooltip title={params.row.modelName}>
              <Typography
                sx={{ cursor: "pointer", fontSize: "0.875rem" }}
                color="primary"
                pl={3}
              >
                {params.row.modelName}
              </Typography>
            </Tooltip>
          </>
        ) : (
          <Tooltip title={params.row.modelName}>
            <Typography sx={{ fontSize: "0.875rem" }}>
              {params.row.modelName}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "title",
      headerName: "Title",
      width: 150,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Tooltip title={params.row.title}>
            <Typography sx={{ fontSize: "0.875rem" }}>
              {params.row.title}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "model",
      headerName: "DMS Model",
      width: 100,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Tooltip title={params.row.model}>
            <Typography sx={{ fontSize: "0.875rem" }}>
              {params.row.model}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "price",
      headerName: "DMS Price ($)",
      headerAlign: "right",
      width: 120,
      filterOperators: customPriceFilterOperators,
      type: "number",
      align: "right",
      sortable: true,
      valueGetter: (params: GridValueGetterParams<any>) => {
        return params.row.pricing === null || params.row.pricing === "UnitPrice"
          ? handleGetGeneralPrice(params.row)
          : handleGetModelPrice(params.row);
      },
    },

    {
      field: "storeprice",
      headerName: "Online Price ($)",
      headerAlign: "right",
      width: 150,
      align: "right",
      type: "number",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.shopifyProduct
          ? getVariantData(params.row)?.price?.toFixed(2)
          : "0.00",
      renderCell: (params) => {
        const { shopifyProduct } = params.row;
        const metafields = shopifyProduct?.metafields || [];
        const hidePrice = metafields.find(
          (metafield: any) =>
            metafield.key === "hidePrice" && metafield.value === "true"
        );

        return (
          <>
            {hidePrice && (
              <Tooltip title="The price of this product is hidden on Shopify">
                <WarningIcon fontSize="small" color="warning" />
              </Tooltip>
            )}
            <Button
              onClick={() => {
                setSelectedRowData(params.row);
                handleGetWGSerials(params.row.model, params.row?.mfrCode);
              }}
            >
              {params.value}
            </Button>
          </>
        );
      },
    },
    {
      field: "cost",
      headerName: "Cost ($)",
      headerAlign: "right",
      width: 100,
      align: "right",
      type: "number",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.cost.toFixed(2),
    },
    {
      field: "isStocking",
      headerName: "Stocking Type",
      headerAlign: "center",
      width: 150,
      align: "center",
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return params?.row?.isStocking ? (
          <Chip label="Stocking" color="success" size="small" />
        ) : (
          <Chip label="Non Stocking" color="warning" size="small" />
        );
      },
    },
    {
      field: "stock",
      headerName: "Stock",
      headerAlign: "right",
      width: 70,
      align: "right",
      type: "number",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) => {
        if (params.row.stock) {
          return params.row?.stock?.reduce(
            (partial: number, value: any) => partial + value.stock,
            0
          );
        }
      },
      renderCell: (params: GridRenderCellParams) => {
        var stock = params.row?.stock?.reduce(
          (partial: number, value: any) => partial + value.stock,
          0
        );
        return (
          <Tooltip
            title={
              <>
                {locations!.map((e, index: number) => {
                  var locationStock = params.row?.stock.find(
                    (n: any) => n.dmsLocationId === e.id
                  );
                  return (
                    <Typography key={index}>
                      {e.name}: {locationStock?.stock ?? 0}
                    </Typography>
                  );
                })}
              </>
            }
          >
            <Typography
              sx={{
                cursor: "pointer",
                fontSize: "inherit",
                lineHeight: "inherit",
                letterSpacing: "inherit",
              }}
            >
              {stock}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: "storeStock",
      headerName: "Online Stock",
      headerAlign: "right",
      width: 100,
      align: "right",
      type: "number",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.shopifyProduct
          ? getVariantData(params.row)?.inventoryQuantity
          : "0.00",
      renderCell: (params) => params.value,
    },
    {
      field: "outOfStock",
      headerName: "OutStock Selling",
      type: "actions",
      width: 130,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return params.row?.shopifyProduct ? (
          <Switch
            size="small"
            aria-labelledby="demo-controlled-radio-buttons-group"
            checked={
              params.row?.shopifyProduct.variants[0].inventoryPolicy.toLowerCase() ===
              "deny"
                ? false
                : true
            }
            name="status"
            onChange={(e) => {
              handleDecisionChangeSingleItem(
                {
                  shopifyProductId: params.row?.shopifyProductId,
                  productAggId: params.row?.id,
                },
                e.target.checked
              );
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        ) : (
          ""
        );
      },
    },
    {
      field: "disableStockSync",
      headerName: "Disable Stock Sync",
      type: "actions",
      width: 160,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Switch
            size="small"
            aria-labelledby="demo-controlled-radio-buttons-group"
            disabled={dmsSetup?.disableStockSync}
            checked={params.row?.disableStockSync || dmsSetup?.disableStockSync}
            name="status"
            onChange={(e) => {
              handleAggregateSyncStatus(
                params.row.id,
                DisableOption.Stock,
                e.target.checked
              );
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      },
    },
    {
      field: "disablePriceSync",
      headerName: "Disable Price Sync",
      type: "actions",
      width: 160,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Switch
            size="small"
            aria-labelledby="demo-controlled-radio-buttons-group"
            checked={params.row?.disablePriceSync || dmsSetup?.disablePriceSync}
            disabled={dmsSetup?.disablePriceSync}
            name="status"
            onChange={(e) => {
              handleAggregateSyncStatus(
                params.row.id,
                DisableOption.Price,
                e.target.checked
              );
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      },
    },
    {
      field: "enableCatalogSync",
      headerName: "Enable Catalog Sync",
      type: "actions",
      width: 160,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Switch
            size="small"
            checked={
              params.row?.matchingType === "Custom" ||
              params.row?.matchingType === "DMS"
                ? false
                : params.row?.enableCatalogSync || dmsSetup?.enableCatalogSync
            }
            disabled={
              dmsSetup?.enableCatalogSync ||
              params.row?.matchingType === "Custom" ||
              params.row?.matchingType === "DMS"
            }
            name="status"
            onChange={(e) => {
              handleAggregateSyncStatus(
                params.row.id,
                DisableOption.Catalog,
                e.target.checked
              );
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      align: "center",
      headerAlign: "center",
      width: 100,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return getStatusChip(params.row);
      },
    },
    {
      field: "type",
      headerName: "Type",
      width: 100,
      align: "center",
      headerAlign: "center",
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return params.row.matchingType === "Catalog" ? (
          <Chip label="Catalog" color="success" size="small" />
        ) : params.row.matchingType === "DMS" ? (
          <Chip label="DMS" color="warning" size="small" />
        ) : (
          <Chip label="Custom" color="info" size="small" />
        );
      },
    },
    {
      field: "actions",
      headerName: "View / Edit",
      type: "actions",
      // width: 80,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <Chip
              label="Action"
              color="info"
              size="small"
              onClick={(event) => {
                setSelectedRowData(params.row);
                setAnchorAction(event.currentTarget);
              }}
            />
            <Menu
              anchorEl={anchorAction}
              open={Boolean(anchorAction)}
              onClose={handleClose}
            >
              <MenuItem
                onClick={() => {
                  window.open(
                    `${dmsSetup?.shopifyUrl}/products/${selectedRowData?.shopifyProductLink}`,
                    "_blank"
                  );
                  setAnchorAction(null);
                }}
              >
                <ListItemIcon>
                  <VisibilityIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>View</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setOpenShopifyDetails(true);
                  setAnchorAction(null);
                }}
              >
                <ListItemIcon>
                  <EditIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Edit</ListItemText>
              </MenuItem>
              <MenuItem
                disabled={
                  selectedRowData?.matchingType !== "Custom" ||
                  !selectedRowData.productId
                }
                onClick={() => {
                  setOpenRevertCustom(true);
                  setAnchorAction(null);
                }}
              >
                <ListItemIcon>
                  <ManageHistoryIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Use Catalog</ListItemText>
              </MenuItem>
            </Menu>
          </>
        );
      },
    },
  ];
  const partsColumns: GridColDef[] = [
    {
      field: "manufacturer",
      headerName: "Manufacturer",
      width: 110,
      filterOperators: ratingOnlyOperators,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.manufacturer,
    },
    {
      field: "inventoryPartId",
      headerName: "Part Id",
      width: 200,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <Typography sx={{ cursor: "pointer" }} color="primary">
              {params.row.inventoryPartId}
            </Typography>
          </>
        );
      },
    },
    {
      field: "partNumber",
      headerName: "Part Number",
      width: 200,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.partNumber,
    },
    {
      field: "price",
      headerName: "DMS Price ($)",
      headerAlign: "right",
      width: 120,
      filterOperators: customPriceFilterOperators,
      type: "number",
      align: "right",
      sortable: true,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.price.toFixed(2),
    },
    {
      field: "suggestedRetailPrice",
      headerName: "DMS Retail Price ($)",
      headerAlign: "right",
      width: 150,
      filterable: false,
      type: "number",
      align: "right",
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.suggestedRetailPrice.toFixed(2),
    },
    {
      field: "storeprice",
      headerName: "Online Price ($)",
      headerAlign: "right",
      width: 120,
      align: "right",
      type: "number",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.shopifyProduct
          ? getVariantData(params.row)?.price?.toFixed(2)
          : "0.00",
      renderCell: (params) => {
        const { shopifyProduct } = params.row;
        const metafields = shopifyProduct?.metafields || [];
        const hidePrice = metafields.find(
          (metafield: any) =>
            metafield.key === "hidePrice" && metafield.value === "true"
        );
        return (
          <>
            {hidePrice && (
              <Tooltip
                sx={{ mr: 1 }}
                title="The price of this product is hidden on Shopify"
              >
                <WarningIcon fontSize="small" color="warning" />
              </Tooltip>
            )}
            {params.value}
          </>
        );
      },
    },
    {
      field: "cost",
      headerName: "Cost ($)",
      headerAlign: "right",
      width: 100,
      align: "right",
      type: "number",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) =>
        params.row.cost.toFixed(2),
    },
    {
      field: "isStocking",
      headerName: "Stocking Type",
      headerAlign: "center",
      width: 150,
      align: "center",
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return params?.row?.isStocking ? (
          <Chip label="Stocking" color="success" size="small" />
        ) : (
          <Chip label="Non Stocking" color="warning" size="small" />
        );
      },
    },
    {
      field: "stock",
      headerName: "Stock",
      headerAlign: "right",
      width: 70,
      align: "right",
      type: "number",
      filterable: false,
      valueGetter: (params: GridValueGetterParams<any>) => {
        if (params.row.stock) {
          return params.row?.stock?.reduce(
            (partial: number, value: any) => partial + value.stock,
            0
          );
        }
      },
    },

    {
      field: "outOfStock",
      headerName: "OutStock Selling",
      type: "actions",
      width: 130,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return params.row?.shopifyProduct ? (
          <Switch
            aria-labelledby="demo-controlled-radio-buttons-group"
            checked={
              params.row?.shopifyProduct.variants[0].inventoryPolicy.toLowerCase() ===
              "deny"
                ? false
                : true
            }
            name="status"
            size="small"
            onChange={(e) => {
              handleDecisionChangeSingleItem(
                {
                  shopifyProductId: params.row?.shopifyProductId,
                  productAggId: params.row?.id,
                },
                e.target.checked
              );
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        ) : (
          ""
        );
      },
    },
    {
      field: "disableStockSync",
      headerName: "Disable Stock Sync",
      type: "actions",
      width: 160,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Switch
            aria-labelledby="demo-controlled-radio-buttons-group"
            disabled={dmsSetup?.disableStockSync}
            checked={params.row?.disableStockSync || dmsSetup?.disableStockSync}
            name="status"
            size="small"
            onChange={(e) => {
              handleAggregateSyncStatus(
                params.row.id,
                DisableOption.Stock,
                e.target.checked
              );
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      },
    },
    {
      field: "disablePriceSync",
      headerName: "Disable Price Sync",
      type: "actions",
      width: 160,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return (
          <Switch
            aria-labelledby="demo-controlled-radio-buttons-group"
            checked={params.row?.disablePriceSync || dmsSetup?.disablePriceSync}
            disabled={dmsSetup?.disablePriceSync}
            name="status"
            size="small"
            onChange={(e) => {
              handleAggregateSyncStatus(
                params.row.id,
                DisableOption.Price,
                e.target.checked
              );
            }}
            inputProps={{ "aria-label": "controlled" }}
          />
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      align: "center",
      headerAlign: "center",
      width: 100,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        return getStatusChip(params.row);
      },
    },
    // {
    //   field: "type",
    //   headerName: "Type",
    //   width: 100,
    //   align: "center",
    //   headerAlign: "center",
    //   filterable: false,
    //   renderCell: (params: GridRenderCellParams) => {
    //     return params.row.productId ? (
    //       <Chip label="Catalog" color="success" size="small" />
    //     ) : (
    //       <Chip label="DMS" color="warning" size="small" />
    //     );
    //   },
    // },
    // {
    //   field: "actions",
    //   headerName: "Action",
    //   type: "actions",
    //   width: 90,
    //   renderCell: (params: GridRenderCellParams) => {
    //     return (
    //       <Chip
    //         label="View"
    //         color="info"
    //         size="small"
    //         onClick={() => {
    //           window.open(
    //             `${dmsSetup?.shopifyUrl}/products/${params.row?.shopifyProductLink}`,
    //             "_blank"
    //           );
    //         }}
    //       />
    //     );
    //   },
    // },

    {
      field: "actions",
      headerName: "View / Edit",
      type: "actions",
      renderCell: (params: GridRenderCellParams) => {
        return (
          <>
            <Chip
              label="Action"
              color="info"
              size="small"
              onClick={(event) => {
                setSelectedRowData(params.row);
                setAnchorAction(event.currentTarget);
              }}
            />
            <Menu
              anchorEl={anchorAction}
              open={Boolean(anchorAction)}
              onClose={handleClose}
            >
              <MenuItem
                onClick={() => {
                  window.open(
                    `${dmsSetup?.shopifyUrl}/products/${selectedRowData?.shopifyProductLink}`,
                    "_blank"
                  );
                  setAnchorAction(null);
                }}
              >
                <ListItemIcon>
                  <VisibilityIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>View</ListItemText>
              </MenuItem>
              <MenuItem
                onClick={() => {
                  setOpenShopifyDetails(true);
                  setAnchorAction(null);
                }}
              >
                <ListItemIcon>
                  <EditIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Edit</ListItemText>
              </MenuItem>
            </Menu>
          </>
        );
      },
    },
  ];

  const getStatusChip = (product: any) => {
    if (product?.shopifyProduct && product.shopifyProduct.status === "ACTIVE")
      return (
        <Chip
          sx={{ cursor: "pointer" }}
          label="Active"
          onDelete={() =>
            handleShowHideSubmit(product.id, product.shopifyProductId, "hide")
          }
          color="success"
          disabled={setVisibilityMutationResult.isLoading}
          size="small"
        />
      );
    else
      return (
        <Chip
          onDelete={() =>
            handleShowHideSubmit(product.id, product.shopifyProductId, "show")
          }
          disabled={setVisibilityMutationResult.isLoading}
          label="Draft"
          color="error"
          size="small"
        />
      );
  };

  React.useEffect(() => {
    fetchData();
  }, [paging, productType]);

  const fetchData = () => {
    syncProduct({
      setupId: dmsSetup?.id ?? "",
      paging: paging,
      productType: productType,
    });
  };

  React.useEffect(() => {
    if (syncProductResult.data) {
      setProducts(syncProductResult.data.entityList);
      setProductsCount(syncProductResult.data.totalRecords);
    }
  }, [syncProductResult]);

  React.useEffect(() => {
    setFormData({
      amount: 0,
      method: "+",
      applyOn: "$",
    });
  }, [addPriceRuleMutationResult]);

  const handlePriceSubmit = (event: any) => {
    if (formData.method !== "reset") {
      if (
        !(formData.amount > 0) ||
        formData.applyOn === "" ||
        formData.method === ""
      ) {
        setShowErrorMessage("Please Fill Amount");
        return;
      }
    }

    let selectedItems = getSelectedRowData();
    addPriceRule({
      products: selectedItems,
      method: formData.method,
      amount: formData.amount,
      applyOn: formData.applyOn,
    });
    setShowErrorMessage("");
    handleClose();
  };

  const handleResetPrice = () => {
    let selectedItems = getSelectedRowData();
    addPriceRule({
      products: selectedItems,
      method: "reset",
      amount: 0,
      applyOn: "",
    });
    setShowErrorMessage("");
    handleClose();
  };

  const handleShowHideSubmit = (
    aggregateId: string,
    shopifyProductId: number,
    action: string
  ) => {
    let selectedItems = [
      { shopifyProductId: shopifyProductId, productAggId: aggregateId },
    ];
    setVisibility({
      products: selectedItems,
      decision: action,
    }).then((res: any) => {
      if (res && res.data.status === 0) {
        setProducts(
          products.map((x) =>
            x.id === aggregateId
              ? {
                  ...x,
                  shopifyProduct: {
                    ...x.shopifyProduct,
                    status: action === "show" ? "ACTIVE" : "DRAFT",
                  },
                }
              : x
          )
        );
      }
    });
  };

  const handleDeleteSubmit = (value: any) => {
    let selectedItems = getSelectedRowData();
    setDeleteProducts({
      products: selectedItems,
      decision: value,
    });
    setDeleteConfirm(false);
  };
  const handleHidePrice = () => {
    let selectedItems = getSelectedRowData();
    if (selectedItems && selectedItems.length > 0) {
      let shopifyProductIds = selectedItems.map(
        (item: any) => item.shopifyProductId
      );
      hidePriceMutation({
        shopifyProductIds: shopifyProductIds,
        hidePrice: hideValue,
      }).then((res: any) => {
        if (res && res.data) {
          if (res.data.status === 200) {
            setAnchorEl(null);
            setOpenHidePrice(false);
            setSelectedRows([]);
            fetchData();
          } else if (res.data.status === 208) {
            setIsOperationRunning(true);
          }
        }
      });
    }
  };
  const hasHiddenPriceProduct = (): boolean => {
    const filteredProducts = products.filter((product: any) =>
      selectedRows.includes(product.id)
    );
    return filteredProducts.some((product: any) => {
      const { shopifyProduct } = product;
      if (shopifyProduct) {
        const metafields = shopifyProduct.metafields || [];
        return metafields.some(
          (metafield: any) =>
            metafield.key === "hidePrice" && metafield.value === "true"
        );
      }
      return false;
    });
  };

  const hasNotHiddenPriceProduct = (): boolean => {
    const filteredProducts = products.filter((product: any) =>
      selectedRows.includes(product.id)
    );
    return filteredProducts.some((product: any) => {
      const { shopifyProduct } = product;
      if (shopifyProduct) {
        const metafields = shopifyProduct.metafields || [];
        return !metafields.some(
          (metafield: any) =>
            metafield.key === "hidePrice" && metafield.value === "true"
        );
      }
      return false;
    });
  };

  const handleStockDecisionSubmit = () => {
    setStockDecision({
      products: getSelectedRowData(),
      decision: checked ? "yes" : "no",
    });
    setOpenStockForm(false);
    setChecked(false);
  };

  const handleStockDecisionSubmitByItem = (product: any, decision: string) => {
    setStockDecisionByItem({
      products: [product],
      decision: decision,
    });
  };

  const getSelectedRowData = () => {
    return selectedRows.map((rowId: any) => {
      let item = products.find((n) => n.id === rowId);

      if (item) {
        return {
          shopifyProductId: item.shopifyProductId,
          productAggId: rowId,
        };
      }
    });
  };

  React.useEffect(() => {
    if (setDeleteProductsMutationResult.isSuccess) {
      setSelectedRows([]);
      fetchData();
    }
  }, [setDeleteProductsMutationResult]);

  React.useEffect(() => {
    if (setStockDecisionMutationResult.isSuccess) {
      fetchData();
    }
  }, [setStockDecisionMutationResult]);

  React.useEffect(() => {
    if (addPriceRuleMutationResult.isSuccess) {
      fetchData();
    }
  }, [addPriceRuleMutationResult]);

  React.useEffect(() => {
    if (manufacturersQuery.data)
      dispatch(
        addDealerManufacturers({
          manufacturer: manufacturersQuery.data.entityList ?? [],
        })
      );
  }, [manufacturersQuery.data]);

  const getIconImageUrl = (imgUrl: string) => {
    var splitImageUrl = imgUrl.slice(0, imgUrl.lastIndexOf("."));
    var extention = imgUrl.slice(imgUrl.lastIndexOf("."));
    return splitImageUrl + "_350x350" + extention;
  };

  const handleSetDmsSetupSyncStatus = (
    disableOption: DisableOption,
    isDisable: boolean
  ) => {
    setSyncStatusMutation({
      request: {
        entityId: setupId ?? "",
        disableOption: disableOption,
        isDisable: isDisable,
        entityType: EntityType.DmsSetup,
      },
    });
    if (disableOption == DisableOption.Stock) {
      dispatch(setDisableStockSync({ disableSync: isDisable }));
    } else if (disableOption == DisableOption.Price) {
      dispatch(setDisablePriceSync({ disableSync: isDisable }));
    } else if (disableOption == DisableOption.Catalog) {
      dispatch(setEnableCatalogSync({ enableSync: isDisable }));
    }
  };
  const handleAggregateSyncStatus = (
    id: string,
    disableOption: DisableOption,
    isDisable: boolean
  ) => {
    setSyncStatusMutation({
      request: {
        entityId: id,
        disableOption: disableOption,
        isDisable: isDisable,
        entityType: EntityType.ProductAggregate,
      },
    });
    if (disableOption == DisableOption.Price) {
      setProducts(
        products.map((item) =>
          item.id === id ? { ...item, disablePriceSync: isDisable } : item
        )
      );
    } else if (disableOption == DisableOption.Stock) {
      setProducts(
        products.map((item) =>
          item.id === id ? { ...item, disableStockSync: isDisable } : item
        )
      );
    } else if (disableOption == DisableOption.Catalog) {
      setProducts(
        products.map((item) =>
          item.id === id ? { ...item, enableCatalogSync: isDisable } : item
        )
      );
    }
  };

  return (
    <>
      <Container maxWidth={false}>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={8}>
            <Grid item xs={4}>
              <Typography variant="h6" sx={{ fontWeight: "bold" }} gutterBottom>
                Product Manager
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <Grid container sx={{ justifyContent: "right" }} spacing={2}>
                <Grid item>
                  <Typography
                    sx={{ fontWeight: "bold", pt: "5px" }}
                    variant="subtitle2"
                    gutterBottom
                  >
                    Apply Rule:
                  </Typography>
                </Grid>
                <Grid item>
                  <Button
                    id="basic-button"
                    aria-controls={open ? "basic-menu" : undefined}
                    aria-haspopup="true"
                    disabled={selectedRows.length === 0 ? true : false}
                    color="warning"
                    variant="contained"
                    size="small"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                    endIcon={<KeyboardArrowDownIcon />}
                    startIcon={
                      addPriceRuleMutationResult.isLoading ? (
                        <CircularProgress size="1.2rem" color="inherit" />
                      ) : (
                        ""
                      )
                    }
                  >
                    Price
                  </Button>
                  <Menu
                    id="basic-menu"
                    anchorEl={anchorEl}
                    open={openPriceMenu}
                    onClose={handleClose}
                    MenuListProps={{
                      "aria-labelledby": "basic-button",
                    }}
                  >
                    <MenuItem
                      onClick={() => {
                        setOpen(true);
                      }}
                    >
                      Reset Price
                    </MenuItem>
                    <MenuItem
                      onClick={() => {
                        setOpenPriceRule(true);
                      }}
                    >
                      Price Rule
                    </MenuItem>
                    <MenuItem
                      disabled={
                        Boolean(anchorEl) && !hasNotHiddenPriceProduct()
                      }
                      onClick={() => {
                        setIsOperationRunning(false);
                        setHideValue(true);
                        setOpenHidePrice(true);
                      }}
                    >
                      Hide Price
                    </MenuItem>
                    <MenuItem
                      disabled={Boolean(anchorEl) && !hasHiddenPriceProduct()}
                      onClick={() => {
                        setIsOperationRunning(false);
                        setHideValue(false);
                        setOpenHidePrice(true);
                      }}
                    >
                      Show Price
                    </MenuItem>
                  </Menu>
                  <Button
                    disabled={
                      (selectedRows.length === 0 ? true : false) ||
                      setDeleteProductsMutationResult.isLoading
                    }
                    color="warning"
                    sx={{ ml: 2 }}
                    variant="contained"
                    size="small"
                    onClick={() => {
                      setDeleteConfirm(true);
                    }}
                    startIcon={
                      setDeleteProductsMutationResult.isLoading ? (
                        <CircularProgress size="1.2rem" color="inherit" />
                      ) : (
                        ""
                      )
                    }
                  >
                    Delete
                  </Button>
                  <Button
                    disabled={
                      (selectedRows.length === 0 ? true : false) ||
                      setStockDecisionMutationResult.isLoading
                    }
                    color="warning"
                    sx={{ ml: 2 }}
                    variant="contained"
                    size="small"
                    onClick={(e) => {
                      setOpenStockForm(true);
                    }}
                    startIcon={
                      setStockDecisionMutationResult.isLoading ? (
                        <CircularProgress size="1.2rem" color="inherit" />
                      ) : (
                        ""
                      )
                    }
                  >
                    Inventory
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            gap={1.5}
          >
            <Typography
              sx={{ fontWeight: "bold", pt: "5px" }}
              variant="subtitle2"
              gutterBottom
            >
              Sync Status:
            </Typography>

            <FormControlLabel
              control={
                <Switch
                  size="small"
                  checked={dmsSetup?.disableStockSync}
                  onChange={(e: any) =>
                    handleSetDmsSetupSyncStatus(
                      DisableOption.Stock,
                      e.target.checked
                    )
                  }
                  name="disableStock"
                  color="warning"
                />
              }
              label="Disable Stock Sync"
            />
            <FormControlLabel
              control={
                <Switch
                  size="small"
                  checked={dmsSetup?.disablePriceSync}
                  onChange={(e: any) =>
                    handleSetDmsSetupSyncStatus(
                      DisableOption.Price,
                      e.target.checked
                    )
                  }
                  name="disablePrice"
                  color="warning"
                />
              }
              label="Disable Price Sync"
            />
            {value !== "Parts" && (
              <FormControlLabel
                control={
                  <Switch
                    size="small"
                    checked={dmsSetup?.enableCatalogSync}
                    onChange={(e: any) =>
                      handleSetDmsSetupSyncStatus(
                        DisableOption.Catalog,
                        e.target.checked
                      )
                    }
                    name="enableCatalogSync"
                    color="warning"
                  />
                }
                label="Enable Catalog Sync"
              />
            )}
          </Box>
          <Box
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
            gap={1.5}
          >
            <Typography
              sx={{ fontWeight: "bold", pt: "5px" }}
              variant="subtitle2"
              gutterBottom
            >
              Price Type:
            </Typography>
            <GetPriceNames
              price={
                PricingType[
                  (dmsSetup?.pricing ?? "Price") as keyof typeof PricingType
                ]
              }
            />
            <Link
              sx={{ cursor: "pointer", fontStyle: "italic" }}
              onClick={() => {
                setOpenPriceType(true);
              }}
            >
              Change
            </Link>
          </Box>
        </Box>

        <Card>
          <CardContent sx={{ padding: 0, paddingBottom: "0px !important" }}>
            <TabContext value={value.toString()}>
              <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
                <TabList
                  onChange={handleTabChange}
                  aria-label="lab API tabs example"
                >
                  {productTypes?.some((n) => n === "Wholegoods") && (
                    <Tab label={"Wholegoods"} value={"Wholegoods"} />
                  )}
                  {productTypes?.some((n) => n === "Parts") && (
                    <Tab label={"Parts"} value={"Parts"} />
                  )}
                </TabList>
              </Box>

              {
                <TabPanel value="Wholegoods" style={{ padding: 0 }}>
                  <ServerAppGrid
                    data={syncProductResult.isLoading ? [] : products}
                    columns={GetAppGridColumns(
                      columns,
                      WGgridSetting?.columnVisibilityModel
                    )}
                    isLoading={syncProductResult.isLoading}
                    selectedRows={selectedRows}
                    onSelect={(newSelection: any) => {
                      setSelectedRows(newSelection);
                    }}
                    paging={paging}
                    setPaging={setPaging}
                    totalRecords={productsCount}
                    keepNonExistentRowsSelected={false}
                    gridId={AppGridId.Product_Manager_Wholegoods}
                    height={"70vh"}
                  ></ServerAppGrid>
                </TabPanel>
              }
              <TabPanel value="Parts" style={{ padding: 0 }}>
                <ServerAppGrid
                  data={syncProductResult.isLoading ? [] : products}
                  columns={GetAppGridColumns(
                    partsColumns,
                    PartgridSetting?.columnVisibilityModel
                  )}
                  isLoading={syncProductResult.isLoading}
                  selectedRows={selectedRows}
                  onSelect={(newSelection: any) => {
                    setSelectedRows(newSelection);
                  }}
                  paging={paging}
                  setPaging={setPaging}
                  totalRecords={productsCount}
                  keepNonExistentRowsSelected={false}
                  gridId={AppGridId.Product_Manager_Parts}
                  height={"70vh"}
                ></ServerAppGrid>
              </TabPanel>
            </TabContext>
          </CardContent>
        </Card>
        <GridWithNewPrices handleClose={handleClose} isOpen={openPriceType} />
      </Container>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title"
        maxWidth="md"
      >
        <DialogTitle sx={{ textAlign: "center" }}>Reset Price</DialogTitle>
        <DialogContent>
          <Typography>
            Any increment or decrement in online price will be reset and General
            selected price will be applied.
          </Typography>
        </DialogContent>
        <DialogActions sx={{ mt: 3 }}>
          <Button
            variant="outlined"
            size="small"
            autoFocus
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button variant="contained" size="small" onClick={handleResetPrice}>
            Reset
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog open={openPriceRule} onClose={handleClose} fullWidth>
        <DialogTitle sx={{ textAlign: "center" }}>Apply Price Rule</DialogTitle>
        <DialogContent>
          <Grid mt={2} container justifyContent="space-between">
            <Grid item md={3}>
              <Typography
                sx={{ fontWeight: "bold", pt: 1 }}
                variant="subtitle2"
                gutterBottom
              >
                Method
              </Typography>
            </Grid>
            <Grid item md={5}>
              <Typography
                sx={{ fontWeight: "bold", pt: 1 }}
                variant="subtitle2"
                gutterBottom
              >
                Amount
              </Typography>
            </Grid>
            <Grid pl={1} item md={4}>
              <Typography
                sx={{ fontWeight: "bold", pt: 1 }}
                variant="subtitle2"
                gutterBottom
              >
                ApplyOn
              </Typography>
            </Grid>
          </Grid>
          <Grid mt={0} container justifyContent="space-between">
            <Grid item md={3}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="method"
                value={formData.method}
                onChange={handleChange}
                sx={{ display: "flex", flexDirection: "column" }}
              >
                <FormControlLabel
                  value={"+"}
                  control={<Radio />}
                  label={<Typography fontSize="0.8rem">Increase</Typography>}
                />
                <FormControlLabel
                  value={"-"}
                  control={<Radio />}
                  label={<Typography fontSize="0.8rem">Decrease</Typography>}
                />
              </RadioGroup>
            </Grid>
            <Grid item md={5} mt={2}>
              <TextField
                variant="standard"
                name="amount"
                fullWidth
                size="small"
                required
                value={formData.amount}
                onChange={handleChange}
              />
            </Grid>
            <Grid pl={1} item md={4}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="applyOn"
                value={formData.applyOn}
                onChange={handleChange}
                sx={{ display: "flex", flexDirection: "column" }}
              >
                <FormControlLabel
                  value={"$"}
                  control={<Radio />}
                  label={<Typography fontSize="0.8rem">Dollars $</Typography>}
                />
                <FormControlLabel
                  value={"%"}
                  control={<Radio />}
                  label={<Typography fontSize="0.8rem">Percent %</Typography>}
                />
              </RadioGroup>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Typography mr="12%" color="red">
            {showErrorMessage}
          </Typography>
          <Button
            variant="outlined"
            size="small"
            autoFocus
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button variant="contained" size="small" onClick={handlePriceSubmit}>
            Apply
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openStockForm}
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title"
        fullWidth
      >
        <DialogTitle sx={{ textAlign: "center" }}>Stock Decision</DialogTitle>
        <DialogContent>
          <FormLabel id="demo-controlled-radio-buttons-group">
            Do you want to sell these items even if it's out of stock?
          </FormLabel>
          <Stack
            direction="row"
            spacing={1}
            justifyContent="center"
            alignItems="center"
            mt={3}
          >
            <Typography>No</Typography>
            <Switch
              aria-labelledby="demo-controlled-radio-buttons-group"
              checked={checked}
              name="status"
              onChange={handleDecisionChange}
              inputProps={{ "aria-label": "controlled" }}
            />
            <Typography>Yes</Typography>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button size="small" variant="outlined" onClick={handleClose}>
            Cancel
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={handleStockDecisionSubmit}
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={deleteConfirm}
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          style={{ textAlign: "center" }}
          id="draggable-dialog-title"
        >
          Confirm to delete
        </DialogTitle>
        <DialogContent>Are you sure to delete selected Products?</DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              setDeleteConfirm(false);
            }}
          >
            No
          </Button>
          <Button
            variant="contained"
            size="small"
            onClick={() => handleDeleteSubmit("delete")}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openHidePrice}
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          style={{ textAlign: "center" }}
          id="draggable-dialog-title"
        >
          Confirm to {hideValue ? "Hide" : "Show"} Price
        </DialogTitle>
        <DialogContent>
          The prices and "Add to Cart" buttons of selected products will{" "}
          {hideValue ? "be hide " : "start to shown "}
          on Shopify?
          <br />
          Are you sure to perform this action?{" "}
          {isOperationRunning ? (
            <Alert sx={{ mt: 1 }} severity="warning">
              A bulk operation in shopify is already running. Please wait for a
              while!
            </Alert>
          ) : (
            ""
          )}
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            size="small"
            onClick={() => {
              setOpenHidePrice(false);
            }}
          >
            No
          </Button>
          <Button
            variant="contained"
            size="small"
            disabled={hidePriceMutationMutationResult.isLoading}
            endIcon={
              hidePriceMutationMutationResult.isLoading ? (
                <CircularProgress size="1.2rem" />
              ) : null
            }
            onClick={handleHidePrice}
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        fullWidth
        open={openPrices}
        onClose={handleClose}
        PaperProps={{
          style: { height: "70vh" },
        }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: "2px",
            paddingBottom: "2px",
          }}
        >
          <Typography color="primary" sx={{ fontWeight: "bold" }}>
            Pricing
          </Typography>
          <IconButton
            onClick={() => {
              handleClose();
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <TabContext value={priceTabsvalue.toString()}>
            <TabList onChange={handlePriceChartTabChange}>
              {" "}
              <Tab label={"Prices"} value={"Prices"} />
              <Tab label={"Units"} value={"Units"} />
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-end",
                  width: "100%",
                }}
              >
                <Tooltip title="After resetting, general price will be applied on this product">
                  <Button
                    disabled={updatePriceMutationResult.isLoading}
                    sx={{
                      height: "25px",
                      fontSize: "0.7125rem",
                    }}
                    variant="contained"
                    color="error"
                    size="small"
                    onClick={() => {
                      const key = dmsSetup?.pricing ?? "Price";
                      const enumValue =
                        PricingType[key as keyof typeof PricingType];
                      handleUpdatePrice(enumValue, null, true);
                    }}
                  >
                    {updatePriceMutationResult.isLoading && isResetRequest ? (
                      <CircularProgress size="1.2rem" color="inherit" />
                    ) : (
                      "Reset Price"
                    )}
                  </Button>
                </Tooltip>
              </Box>
            </TabList>
            <TabPanel value="Prices" sx={{ padding: 0 }}>
              <Table aria-label="customized table">
                <TableBody>
                  <StyledTableRow
                    sx={{
                      height: "40px",
                      backgroundColor: "rgba(0, 0, 0, 0.04) !important",
                    }}
                  >
                    <StyledTableCell
                      sx={{ color: "primary", fontWeight: "bold" }}
                      align="center"
                      colSpan={3}
                    >
                      Model Level Price
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow
                    sx={{
                      backgroundColor: handleGetRowColor(PricingType.Price),
                    }}
                  >
                    <StyledTableCell width="40%">Price</StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.aggregatePrices?.price?.toFixed(2) ?? 0}{" "}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.pricing ===
                      PricingType[PricingType.Price] ? (
                        <Chip label="Applied" color="success" size="small" />
                      ) : (
                        <Button
                          disabled={
                            selectedRowData?.price === null ||
                            selectedRowData?.price === 0 ||
                            updatePriceMutationResult.isLoading
                          }
                          sx={{ lineHeight: "1.4", fontSize: "0.7125rem" }}
                          variant="contained"
                          color="warning"
                          size="small"
                          onClick={() => {
                            handleUpdatePrice(PricingType.Price, null, false);
                          }}
                        >
                          {updatePriceMutationResult.isLoading &&
                          priceType === PricingType.Price &&
                          !isResetRequest ? (
                            <CircularProgress size="1.2rem" color="inherit" />
                          ) : (
                            "Apply"
                          )}
                        </Button>
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow
                    sx={{
                      height: "40px",
                      backgroundColor: "rgba(0, 0, 0, 0.04) !important",
                    }}
                  >
                    <StyledTableCell
                      sx={{ color: "primary", fontWeight: "bold" }}
                      align="center"
                      colSpan={3}
                    >
                      Stocked Units
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow
                    sx={{
                      backgroundColor: handleGetRowColor(
                        PricingType.UnitListPriceLargestStock
                      ),
                    }}
                  >
                    <StyledTableCell width="40%">
                      Unit List Price Highest
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.aggregatePrices?.unitListPriceLargestStock?.toFixed(
                        2
                      ) ?? 0}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.pricing ===
                      PricingType[PricingType.UnitListPriceLargestStock] ? (
                        <Chip label="Applied" color="success" size="small" />
                      ) : (
                        <Button
                          disabled={
                            selectedRowData?.aggregatePrices
                              ?.unitListPriceLargestStock === null ||
                            selectedRowData?.aggregatePrices
                              ?.unitListPriceLargestStock === 0 ||
                            updatePriceMutationResult.isLoading
                          }
                          sx={{ lineHeight: "1.4", fontSize: "0.7125rem" }}
                          variant="contained"
                          color="warning"
                          size="small"
                          onClick={() => {
                            handleUpdatePrice(
                              PricingType.UnitListPriceLargestStock,
                              null,
                              false
                            );
                          }}
                        >
                          {updatePriceMutationResult.isLoading &&
                          priceType === PricingType.UnitListPriceLargestStock &&
                          !isResetRequest ? (
                            <CircularProgress size="1.2rem" color="inherit" />
                          ) : (
                            "Apply"
                          )}
                        </Button>
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow
                    sx={{
                      backgroundColor: handleGetRowColor(
                        PricingType.UnitListPriceSmallestStock
                      ),
                    }}
                  >
                    <StyledTableCell width="40%">
                      Unit List Price Lowest
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.aggregatePrices?.unitListPriceSmallestStock?.toFixed(
                        2
                      ) ?? 0}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.pricing ===
                      PricingType[PricingType.UnitListPriceSmallestStock] ? (
                        <Chip label="Applied" color="success" size="small" />
                      ) : (
                        <Button
                          disabled={
                            selectedRowData?.aggregatePrices
                              ?.unitListPriceSmallestStock === null ||
                            selectedRowData?.aggregatePrices
                              ?.unitListPriceSmallestStock === 0 ||
                            updatePriceMutationResult.isLoading
                          }
                          sx={{ lineHeight: "1.4", fontSize: "0.7125rem" }}
                          variant="contained"
                          color="warning"
                          size="small"
                          onClick={() => {
                            handleUpdatePrice(
                              PricingType.UnitListPriceSmallestStock,
                              null,
                              false
                            );
                          }}
                        >
                          {updatePriceMutationResult.isLoading &&
                          priceType ===
                            PricingType.UnitListPriceSmallestStock &&
                          !isResetRequest ? (
                            <CircularProgress size="1.2rem" color="inherit" />
                          ) : (
                            "Apply"
                          )}
                        </Button>
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow
                    sx={{
                      backgroundColor: handleGetRowColor(
                        PricingType.UnitListPriceLatestStock
                      ),
                    }}
                  >
                    <StyledTableCell width="40%">
                      Unit List Price Latest{" "}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.aggregatePrices?.unitListPriceLatestStock?.toFixed(
                        2
                      ) ?? 0}{" "}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.pricing ===
                      PricingType[PricingType.UnitListPriceLatestStock] ? (
                        <Chip label="Applied" color="success" size="small" />
                      ) : (
                        <Button
                          disabled={
                            selectedRowData?.aggregatePrices
                              ?.unitListPriceLatestStock === null ||
                            selectedRowData?.aggregatePrices
                              ?.unitListPriceLatestStock === 0 ||
                            updatePriceMutationResult.isLoading
                          }
                          sx={{ lineHeight: "1.4", fontSize: "0.7125rem" }}
                          variant="contained"
                          color="warning"
                          size="small"
                          onClick={() => {
                            handleUpdatePrice(
                              PricingType.UnitListPriceLatestStock,
                              null,
                              false
                            );
                          }}
                        >
                          {updatePriceMutationResult.isLoading &&
                          priceType === PricingType.UnitListPriceLatestStock ? (
                            <CircularProgress size="1.2rem" color="inherit" />
                          ) : (
                            "Apply"
                          )}
                        </Button>
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow
                    sx={{
                      backgroundColor: handleGetRowColor(
                        PricingType.MSRPListPriceLargestStock
                      ),
                    }}
                  >
                    <StyledTableCell width="40%">
                      MSRP List Price Highest
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.aggregatePrices?.msrpListPriceLargestStock?.toFixed(
                        2
                      ) ?? 0}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.pricing ===
                      PricingType[PricingType.MSRPListPriceLargestStock] ? (
                        <Chip label="Applied" color="success" size="small" />
                      ) : (
                        <Button
                          disabled={
                            selectedRowData?.aggregatePrices
                              ?.msrpListPriceLargestStock === null ||
                            selectedRowData?.aggregatePrices
                              ?.msrpListPriceLargestStock === 0 ||
                            updatePriceMutationResult.isLoading
                          }
                          sx={{ lineHeight: "1.4", fontSize: "0.7125rem" }}
                          variant="contained"
                          color="warning"
                          size="small"
                          onClick={() => {
                            handleUpdatePrice(
                              PricingType.MSRPListPriceLargestStock,
                              null,
                              false
                            );
                          }}
                        >
                          {updatePriceMutationResult.isLoading &&
                          priceType === PricingType.MSRPListPriceLargestStock &&
                          !isResetRequest ? (
                            <CircularProgress size="1.2rem" color="inherit" />
                          ) : (
                            "Apply"
                          )}
                        </Button>
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow
                    sx={{
                      backgroundColor: handleGetRowColor(
                        PricingType.MSRPListPriceSmallestStock
                      ),
                    }}
                  >
                    <StyledTableCell width="40%">
                      MSRP List Price Lowest
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.aggregatePrices?.msrpListPriceSmallestStock?.toFixed(
                        2
                      ) ?? 0}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.pricing ===
                      PricingType[PricingType.MSRPListPriceSmallestStock] ? (
                        <Chip label="Applied" color="success" size="small" />
                      ) : (
                        <Button
                          disabled={
                            selectedRowData?.aggregatePrices
                              ?.msrpListPriceSmallestStock === null ||
                            selectedRowData?.aggregatePrices
                              ?.msrpListPriceSmallestStock === 0 ||
                            updatePriceMutationResult.isLoading
                          }
                          sx={{ lineHeight: "1.4", fontSize: "0.7125rem" }}
                          variant="contained"
                          color="warning"
                          size="small"
                          onClick={() => {
                            handleUpdatePrice(
                              PricingType.MSRPListPriceSmallestStock,
                              null,
                              false
                            );
                          }}
                        >
                          {updatePriceMutationResult.isLoading &&
                          priceType ===
                            PricingType.MSRPListPriceSmallestStock &&
                          !isResetRequest ? (
                            <CircularProgress size="1.2rem" color="inherit" />
                          ) : (
                            "Apply"
                          )}
                        </Button>
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow
                    sx={{
                      backgroundColor: handleGetRowColor(
                        PricingType.MSRPListPriceLatestStock
                      ),
                    }}
                  >
                    <StyledTableCell width="40%">
                      MSRP List Price Latest
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.aggregatePrices?.msrpListPriceLatestStock?.toFixed(
                        2
                      ) ?? 0}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.pricing ===
                      PricingType[PricingType.MSRPListPriceLatestStock] ? (
                        <Chip label="Applied" color="success" size="small" />
                      ) : (
                        <Button
                          disabled={
                            selectedRowData?.aggregatePrices
                              ?.msrpListPriceLatestStock === null ||
                            selectedRowData?.aggregatePrices
                              ?.msrpListPriceLatestStock === 0 ||
                            updatePriceMutationResult.isLoading
                          }
                          sx={{ lineHeight: "1.4", fontSize: "0.7125rem" }}
                          variant="contained"
                          color="warning"
                          size="small"
                          onClick={() => {
                            handleUpdatePrice(
                              PricingType.MSRPListPriceLatestStock,
                              null,
                              false
                            );
                          }}
                        >
                          {updatePriceMutationResult.isLoading &&
                          priceType === PricingType.MSRPListPriceLatestStock &&
                          !isResetRequest ? (
                            <CircularProgress size="1.2rem" color="inherit" />
                          ) : (
                            "Apply"
                          )}
                        </Button>
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow
                    sx={{
                      height: "40px",
                      backgroundColor: "rgba(0, 0, 0, 0.04) !important",
                    }}
                  >
                    <StyledTableCell
                      sx={{ color: "primary", fontWeight: "bold" }}
                      align="center"
                      colSpan={3}
                    >
                      Sold Units
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow
                    sx={{
                      backgroundColor: handleGetRowColor(
                        PricingType.UnitListPriceLargest
                      ),
                    }}
                  >
                    <StyledTableCell width="40%">
                      Unit List Price Highest
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.aggregatePrices?.unitListPriceLargest?.toFixed(
                        2
                      ) ?? 0}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.pricing ===
                      PricingType[PricingType.UnitListPriceLargest] ? (
                        <Chip label="Applied" color="success" size="small" />
                      ) : (
                        <Button
                          disabled={
                            selectedRowData?.aggregatePrices
                              ?.unitListPriceLargest === null ||
                            selectedRowData?.aggregatePrices
                              ?.unitListPriceLargest === 0 ||
                            updatePriceMutationResult.isLoading
                          }
                          sx={{ lineHeight: "1.4", fontSize: "0.7125rem" }}
                          variant="contained"
                          color="warning"
                          size="small"
                          onClick={() => {
                            handleUpdatePrice(
                              PricingType.UnitListPriceLargest,
                              null,
                              false
                            );
                          }}
                        >
                          {updatePriceMutationResult.isLoading &&
                          priceType === PricingType.UnitListPriceLargest &&
                          !isResetRequest ? (
                            <CircularProgress size="1.2rem" color="inherit" />
                          ) : (
                            "Apply"
                          )}
                        </Button>
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow
                    sx={{
                      backgroundColor: handleGetRowColor(
                        PricingType.UnitListPriceSmallest
                      ),
                    }}
                  >
                    <StyledTableCell width="40%">
                      Unit List Price Lowest
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.aggregatePrices?.unitListPriceSmallest?.toFixed(
                        2
                      ) ?? 0}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.pricing ===
                      PricingType[PricingType.UnitListPriceSmallest] ? (
                        <Chip label="Applied" color="success" size="small" />
                      ) : (
                        <Button
                          disabled={
                            selectedRowData?.aggregatePrices
                              ?.unitListPriceSmallest === null ||
                            selectedRowData?.aggregatePrices
                              ?.unitListPriceSmallest === 0 ||
                            updatePriceMutationResult.isLoading
                          }
                          sx={{ lineHeight: "1.4", fontSize: "0.7125rem" }}
                          variant="contained"
                          color="warning"
                          size="small"
                          onClick={() => {
                            handleUpdatePrice(
                              PricingType.UnitListPriceSmallest,
                              null,
                              false
                            );
                          }}
                        >
                          {updatePriceMutationResult.isLoading &&
                          priceType === PricingType.UnitListPriceSmallest &&
                          !isResetRequest ? (
                            <CircularProgress size="1.2rem" color="inherit" />
                          ) : (
                            "Apply"
                          )}
                        </Button>
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow
                    sx={{
                      backgroundColor: handleGetRowColor(
                        PricingType.UnitListPriceLatest
                      ),
                    }}
                  >
                    <StyledTableCell width="40%">
                      Unit List Price Latest
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {" "}
                      {selectedRowData?.aggregatePrices?.unitListPriceLatest?.toFixed(
                        2
                      ) ?? 0}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.pricing ===
                      PricingType[PricingType.UnitListPriceLatest] ? (
                        <Chip label="Applied" color="success" size="small" />
                      ) : (
                        <Button
                          disabled={
                            selectedRowData?.aggregatePrices
                              ?.unitListPriceLatest === null ||
                            selectedRowData?.aggregatePrices
                              ?.unitListPriceLatest === 0 ||
                            updatePriceMutationResult.isLoading
                          }
                          sx={{ lineHeight: "1.4", fontSize: "0.7125rem" }}
                          variant="contained"
                          color="warning"
                          size="small"
                          onClick={() => {
                            handleUpdatePrice(
                              PricingType.UnitListPriceLatest,
                              null,
                              false
                            );
                          }}
                        >
                          {updatePriceMutationResult.isLoading &&
                          priceType === PricingType.UnitListPriceLatest &&
                          !isResetRequest ? (
                            <CircularProgress size="1.2rem" color="inherit" />
                          ) : (
                            "Apply"
                          )}
                        </Button>
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow
                    sx={{
                      backgroundColor: handleGetRowColor(
                        PricingType.MSRPListPriceLargest
                      ),
                    }}
                  >
                    <StyledTableCell width="40%">
                      MSRP List Price Highest{" "}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.aggregatePrices?.msrpListPriceLargest?.toFixed(
                        2
                      ) ?? 0}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.pricing ===
                      PricingType[PricingType.MSRPListPriceLargest] ? (
                        <Chip label="Applied" color="success" size="small" />
                      ) : (
                        <Button
                          disabled={
                            selectedRowData?.aggregatePrices
                              ?.msrpListPriceLargest === null ||
                            selectedRowData?.aggregatePrices
                              ?.msrpListPriceLargest === 0 ||
                            updatePriceMutationResult.isLoading
                          }
                          sx={{ lineHeight: "1.4", fontSize: "0.7125rem" }}
                          variant="contained"
                          color="warning"
                          size="small"
                          onClick={() => {
                            handleUpdatePrice(
                              PricingType.MSRPListPriceLargest,
                              null,
                              false
                            );
                          }}
                        >
                          {updatePriceMutationResult.isLoading &&
                          priceType === PricingType.MSRPListPriceLargest &&
                          !isResetRequest ? (
                            <CircularProgress size="1.2rem" color="inherit" />
                          ) : (
                            "Apply"
                          )}
                        </Button>
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow
                    sx={{
                      backgroundColor: handleGetRowColor(
                        PricingType.MSRPListPriceSmallest
                      ),
                    }}
                  >
                    <StyledTableCell width="40%">
                      MSRP List Price Lowest
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.aggregatePrices?.msrpListPriceSmallest?.toFixed(
                        2
                      ) ?? 0}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.pricing ===
                      PricingType[PricingType.MSRPListPriceSmallest] ? (
                        <Chip label="Applied" color="success" size="small" />
                      ) : (
                        <Button
                          disabled={
                            selectedRowData?.aggregatePrices
                              ?.msrpListPriceSmallest === null ||
                            selectedRowData?.aggregatePrices
                              ?.msrpListPriceSmallest === 0 ||
                            updatePriceMutationResult.isLoading
                          }
                          sx={{ lineHeight: "1.4", fontSize: "0.7125rem" }}
                          variant="contained"
                          color="warning"
                          size="small"
                          onClick={() => {
                            handleUpdatePrice(
                              PricingType.MSRPListPriceSmallest,
                              null,
                              false
                            );
                          }}
                        >
                          {updatePriceMutationResult.isLoading &&
                          priceType === PricingType.MSRPListPriceSmallest &&
                          !isResetRequest ? (
                            <CircularProgress size="1.2rem" color="inherit" />
                          ) : (
                            "Apply"
                          )}
                        </Button>
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                  <StyledTableRow
                    sx={{
                      backgroundColor: handleGetRowColor(
                        PricingType.MSRPListPriceLatest
                      ),
                    }}
                  >
                    <StyledTableCell width="40%">
                      MSRP List Price Latest
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.aggregatePrices?.msrpListPriceLatest?.toFixed(
                        2
                      ) ?? 0}
                    </StyledTableCell>
                    <StyledTableCell align="right">
                      {selectedRowData?.pricing ===
                      PricingType[PricingType.MSRPListPriceLatest] ? (
                        <Chip label="Applied" color="success" size="small" />
                      ) : (
                        <Button
                          disabled={
                            selectedRowData?.aggregatePrices
                              ?.msrpListPriceSmallest === null ||
                            selectedRowData?.aggregatePrices
                              ?.msrpListPriceSmallest === 0 ||
                            updatePriceMutationResult.isLoading
                          }
                          sx={{ lineHeight: "1.4", fontSize: "0.7125rem" }}
                          variant="contained"
                          color="warning"
                          size="small"
                          onClick={() => {
                            handleUpdatePrice(
                              PricingType.MSRPListPriceLatest,
                              null,
                              false
                            );
                          }}
                        >
                          {updatePriceMutationResult.isLoading &&
                          priceType === PricingType.MSRPListPriceLatest &&
                          !isResetRequest ? (
                            <CircularProgress size="1.2rem" color="inherit" />
                          ) : (
                            "Apply"
                          )}
                        </Button>
                      )}
                    </StyledTableCell>
                  </StyledTableRow>
                </TableBody>
              </Table>
            </TabPanel>
            <TabPanel value="Units" sx={{ padding: 0 }}>
              <Table aria-label="customized table">
                <TableBody>
                  <StyledTableRow
                    sx={{
                      height: "40px",
                      backgroundColor: "rgba(0, 0, 0, 0.04) !important",
                    }}
                  >
                    <StyledTableCell
                      sx={{ color: "primary", fontWeight: "bold" }}
                    >
                      Serial#
                    </StyledTableCell>
                    <StyledTableCell
                      sx={{ color: "primary", fontWeight: "bold" }}
                    >
                      Stock#
                    </StyledTableCell>
                    <StyledTableCell
                      sx={{ color: "primary", fontWeight: "bold" }}
                      align="right"
                    >
                      Price($)
                    </StyledTableCell>
                    <StyledTableCell
                      sx={{ color: "primary", fontWeight: "bold" }}
                      align="right"
                    >
                      MSRP($)
                    </StyledTableCell>
                    <StyledTableCell
                      sx={{ color: "primary", fontWeight: "bold" }}
                      align="center"
                    >
                      Action
                    </StyledTableCell>
                  </StyledTableRow>
                  {getWGSerialsMutationResult.isLoading ? (
                    <StyledTableRow>
                      <StyledTableCell align="center" colSpan={5}>
                        Loading Serials...
                      </StyledTableCell>
                    </StyledTableRow>
                  ) : WGSerials && WGSerials.length > 0 ? (
                    WGSerials.map((wg: any, index: number) => (
                      <StyledTableRow
                        sx={{
                          backgroundColor:
                            selectedRowData?.serialNumber === wg?.serialNumber
                              ? "rgb(237, 247, 237)"
                              : "",
                        }}
                        key={index}
                      >
                        <StyledTableCell>{wg?.serialNumber}</StyledTableCell>
                        <StyledTableCell>{wg?.stockNumber}</StyledTableCell>
                        <StyledTableCell align="right">
                          {wg?.price?.toFixed(2) ?? 0}
                        </StyledTableCell>
                        <StyledTableCell align="right">
                          {wg?.suggestedRetailPrice?.toFixed(2) ?? 0}
                        </StyledTableCell>
                        <StyledTableCell align="center">
                          <Button
                            color="warning"
                            id="basic-button2"
                            aria-haspopup="true"
                            onClick={(e) => {
                              handleClickUnitPrice(e, wg.serialNumber);
                            }}
                            endIcon={<KeyboardArrowDownIcon />}
                            disabled={
                              wg?.price === null ||
                              wg.price === 0 ||
                              updatePriceMutationResult.isLoading
                            }
                            sx={{ lineHeight: "1.4", fontSize: "0.7125rem" }}
                            variant="contained"
                            size="small"
                          >
                            {updatePriceMutationResult.isLoading &&
                            wg?.serialNumber === serialNumber ? (
                              <CircularProgress size="1.2rem" color="inherit" />
                            ) : (
                              "Apply"
                            )}
                          </Button>
                          <Menu
                            id="basic-menu"
                            anchorEl={anchorUnitPrice}
                            open={openUnitPriceMenu}
                            onClose={handleUnitPriceClose}
                            MenuListProps={{
                              "aria-labelledby": "basic-button2",
                            }}
                          >
                            <MenuItem
                              sx={{ lineHeight: "1.4", fontSize: "small" }}
                              onClick={() => {
                                handleUpdatePrice(
                                  PricingType.UnitPrice,
                                  UnitPriceType.UnitList,
                                  false
                                );
                                handleUnitPriceClose();
                              }}
                            >
                              Unit List
                            </MenuItem>
                            <MenuItem
                              sx={{ lineHeight: "1.4", fontSize: "small" }}
                              onClick={() => {
                                handleUpdatePrice(
                                  PricingType.UnitPrice,
                                  UnitPriceType.MSRPList,
                                  false
                                );
                                handleUnitPriceClose();
                              }}
                            >
                              MSRP List
                            </MenuItem>
                          </Menu>{" "}
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                  ) : (
                    <StyledTableRow>
                      <StyledTableCell align="center" colSpan={5}>
                        No Serial Found.
                      </StyledTableCell>
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>
            </TabPanel>
          </TabContext>
        </DialogContent>
      </Dialog>
      <Dialog
        open={openShopifyDetails}
        fullWidth={true}
        maxWidth="lg"
        disableEnforceFocus={true}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            padding: 0,
            paddingLeft: "16px",
            paddingRight: "16px",
          }}
        >
          <h4>Shopify Product Details</h4>
          <IconButton
            onClick={() => {
              handleClose();
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ width: "100%" }}>
          <ShopifyProductDetails
            shopifyProductId={selectedRowData?.shopifyProductId}
            aggregateId={
              value.toString() === "Wholegoods"
                ? selectedRowData?.id
                : undefined
            } //aggregateId decides at backend if need to update catalog sync bit or not
            handleUpdateMatchingType={handleUpdateProductMatchingType}
          ></ShopifyProductDetails>
        </DialogContent>
      </Dialog>
      <Dialog open={openRevertCustom} fullWidth onClose={handleClose}>
        <DialogTitle>Confirm to Revert Custom</DialogTitle>
        <DialogContent>
          Are you sure you want to remove your custom changes and use details
          from Catalog?
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            size="small"
            autoFocus
            onClick={() => {
              setOpenRevertCustom(false);
            }}
          >
            Keep Custom
          </Button>
          <Button
            size="small"
            variant="contained"
            onClick={handleRevertCustomDetails}
            disabled={revertCustomDetailsMutationResult.isLoading}
            endIcon={
              revertCustomDetailsMutationResult.isLoading ? (
                <CircularProgress size="1.2rem" />
              ) : null
            }
          >
            Use Catalog
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ProductManagement;

const getVariantData = (row: any) => {
  let variant = row.shopifyProduct.variants.find(
    (n: any) => n.id.toString() === row.shopifyVariantId
  );

  if (variant === undefined) {
    variant = row.shopifyProduct.variants[0];
  }
  return variant;
};
